import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { startViewTransition } from '@theme/utilities';

/**
 * Blog filters component that handles tag/blog filtering with animated transitions.
 *
 * @extends Component
 */
export default class BlogFilters extends Component {
  connectedCallback() {
    super.connectedCallback();
    // Listen for clicks on all filter links
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
  }

  /**
   * Gets the section ID from the parent main-blog element.
   * @returns {string} The section ID (without shopify-section- prefix).
   */
  get sectionId() {
    const section = this.closest('.shopify-section');
    if (!section?.id) throw new Error('Could not find section ID');
    // Strip the shopify-section- prefix as section-renderer adds it back
    return section.id.replace(/^shopify-section-/, '');
  }

  /**
   * Handles click events on filter links.
   * @param {MouseEvent} event - The click event.
   */
  #handleClick = (event) => {
    const link = /** @type {HTMLElement} */ (event.target)?.closest('a');
    if (!link) return;

    // Prevent default navigation
    event.preventDefault();

    const url = new URL(link.href, window.location.origin);

    // Update browser history
    history.pushState({}, '', url.toString());

    // Re-render section with view transition animation
    startViewTransition(() => sectionRenderer.renderSection(this.sectionId, { url, cache: false }), ['article-grid']);
  };
}

if (!customElements.get('blog-filters')) {
  customElements.define('blog-filters', BlogFilters);
}
